import * as React from 'react'
import {inject, observer} from 'mobx-react'
import CustomModal from 'src/components/containers/CustomModal'
import {StoreProps} from 'src/stores'
import styled from 'styled-components'
import {media} from 'src/utils.js'
import {RedBtn} from '../../atoms/input/buttons'
import {Package} from "../../../resources";

interface State {
  selectedPackage: Package
  packages: Package[]
  loading: boolean
}

@inject('confStore')
@observer
export default class PackageSelectionPopup extends React.Component<StoreProps, State> {

  constructor(props) {
    super(props)
    const { confStore } = this.props
    this.state = {
      selectedPackage: null,
      packages: confStore.getCatalogue.packages,
      loading: false
    }
  }

  componentDidMount() {
    const { confStore } = this.props
    if (confStore.getOffer.products.length == 1 && confStore.getCatalogue.packages) {
      confStore.setPackageSelectionPopup(true)
    }
  }

  handleClose = () => {
    const { confStore } = this.props
    confStore.setPackageSelectionPopup(false)
  }

  submit = () => {
    const { confStore } = this.props
    confStore.setPackageSelectionPopup(false)
  }

  applyPackage = () => {
    const { selectedPackage } = this.state
    this.setState({ loading: true })
    const { confStore } = this.props
    confStore
      .applyPackage(confStore.getOffer.uuid, selectedPackage.id)
      .then(() => {
        // confStore.setPackageSelectionPopup(false)
        window.location.reload()
    })
  }

  selectPackage = (pkg) => {
    this.setState({ selectedPackage: pkg })
  }

  packageSelection = () => {
    const { selectedPackage, packages, loading } = this.state
    return (
      <>
        <ModalText>
          Sie können hier eines unserer beliebten Pakete für eine
          Bestattung wählen. Das Paket kann danach individuell angepasst werden.
        </ModalText>
        <CardContainer>
          {loading ? (
            <h4>Sie werden gleich weitergeleitet ...</h4>
          ) : (packages.map((pkg, index) => {
              return (
                <Card
                  key={pkg.name}
                  onClick={() => this.selectPackage(pkg)}
                  data-ci = {`card-${index}`}
                  selected={selectedPackage != null && selectedPackage.name === pkg.name}>
                  <img src={`${pkg.image}`} alt='package_icon' />
                  <p>
                    {pkg.name}
                    <br />
                    <small>{pkg.description}</small>
                  </p>
                </Card>
              )
            }))}
        </CardContainer>
        <RedBtn data-ci = {`card-submit`} disabled={!selectedPackage} onClick={() => this.applyPackage()}>
          PAKET WÄHLEN
        </RedBtn>
      </>
    )
  }

  render() {
    const { confStore } = this.props
    if(this.state.packages && this.state.packages.length > 0){
      return (
        <CustomModal
          title='Beliebte Pakete für eine Bestattung'
          open={confStore.showPackageSelectionPopup}
          onClose={this.handleClose}
          cancelX
          closeButtonText="Weiter ohne Paket">
          <div>{this.packageSelection()}</div>
        </CustomModal>
      )
    }
   return <></>
  }
}

const ModalText = styled.p`
  display: block;
  max-width: 800px;
  margin: 0 auto 15px auto;
  text-align: center;
`

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: auto;
`

const Card = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 50%;
  min-width: 270px;
  padding: 7.5px;
  margin: 7.5px;
  border-left: 4px solid #677d7f;
  background-image: linear-gradient(to left, #677d7f 50%, #d5e4e6 50%);
  background-size: 200% 100%;
  transition: background-position 0.3s;
  will-change: background-position;
  cursor: pointer;

  &:hover {
    background-position: -100% 0;
    p {
      color: #f0f0f0;
    }
    img {
      filter: grayscale(1) brightness(2);
    }
  }

  & > * {
    margin: 10px;
  }

  img {
    transition: filter 0.3s;
    will-change: filter;
  }

  p {
    line-height: 1;
    text-align: left;
    font-size: 20px;
    color: #4a4a4a;
    transition: color 0.4s;
    will-change: color;

    small {
      font-size: 15px;
    }

    ${media.tablet`
      font-size: 17px;
      small {
        font-size: 13px;
      }
    `}
  }
  ${(props) =>
  props.selected &&
  `
      background-position: -100% 0;
      p {
        color: #f0f0f0;
      }
      img {
        filter: grayscale(1) brightness(2);
      }
   `}
`


// WEBPACK FOOTER //
// ./src/components/organisms/configurator/PackageSelectionPopup.tsx